/**
 * An interface to represent section visibility
 */
export interface SectionVisibility {
  main: any;
  other: any;
}


export enum SectionScope {
  Submission = 'SUBMISSION',
  Workflow = 'WORKFLOW',
}
